import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
    search = '',
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.myProjKpi.getSubmitOrgProjKpiPage, {
        orgId,
        search,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { };
};

